{
  "zh-CN": {
    "tools": {
      "descriptions": {
        "verseGuide": "全面的星际旅行指南，包含详细的星系地图、兴趣点和星际公民宇宙中的探索路线",
        "starCitizenTools": "社区驱动的维基，包含有关飞船、武器、地点、游戏机制和背景故事的详细文档",
        "starship42": "交互式3D飞船查看器，包含详细的外部和内部模型、组件布局和尺寸比较",
        "erkul": "高级DPS计算器和飞船装载优化器，包含详细的武器统计数据和组件比较",
        "starjump": "2D舰队可视化工具，用于创建精美的飞船布局和舰队组织图表",
        "itemFinder": "全面的物品和装备位置数据库，实时跟踪宇宙中的可用性",
        "starHangar": "可信赖的星际公民飞船承诺和包裹市场，提供安全交易和价格跟踪",
        "shinytracker": "个人进度跟踪器，用于任务、声望、成就和探索目标，提供详细统计数据",
        "uexCorp": "实时商品交易平台，包含价格跟踪、贸易路线优化和市场分析工具",
        "cargoGridViewer": "3D货物网格查看器，显示所有飞船的货舱尺寸和集装箱适配情况",
        "scmdb": "浏览星际公民的任务、奖励、声望路径、采矿资源等",
        "regolith": "星际公民采矿工具，提供岩石扫描、精炼计算和采矿头比较",
        "spviewer": "Ship performance analysis tool with detailed flight characteristics, speed comparisons, and maneuverability data",
        "citizenId": "星际公民身份验证和OAuth认证服务，为社区工具提供身份认证",
        "hauler": "星际公民货运路线规划和利润计算工具"
      },
      "categories": {
        "trading": "贸易与经济",
        "loadouts": "飞船装载与战斗",
        "mining": "采矿",
        "guides": "信息与指南",
        "missions": "任务与数据库",
        "roadmap": "路线图与追踪",
        "fleet": "舰队管理",
        "marketplace": "市场"
      },
      "discontinued": "该项目已停止维护。",
      "discontinuedHeading": "已停止的项目"
    }
  }
}
